import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CreateProductService } from './../../api/services/create-product.service';
import { Component, OnInit } from '@angular/core';
import { sendEmailProduts } from 'src/app/api/models/uploadProduct';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PerfilService } from 'src/app/api/services/perfil.service';

@Component({
    selector: 'app-add-produtos',
    templateUrl: './add-produtos.component.html',
    styleUrls: ['./add-produtos.component.css'],
    standalone: false
})
export class AddProdutosComponent implements OnInit {
  submitted: boolean = false;
  myForm!: FormGroup;
  imgType = '.png,.jpeg,.jpg,.gif,.webm';
  fileType = '.pdf';
  excelType = '.xls, .xlsx';

  loggedUser = this.perfilService.getCurrentUserInfo();
  isLoading: boolean = false;

  constructor(
    private perfilService: PerfilService,
    private createProductService: CreateProductService,
    private snackBarService: SnackBarService,
    private fb: FormBuilder,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.myForm = this.fb.group({
      imgProduct: ['', Validators.required],
      technicalFile: [''],
      imgFile: ['', Validators.required],
      flyerFile: [''],
    });
  }

  get imgProduct() {
    return this.myForm.controls['imgProduct'] as FormControl;
  }
  get technicalFile() {
    return this.myForm.controls['technicalFile'] as FormControl;
  }
  get imgFile() {
    return this.myForm.controls['imgFile'] as FormControl;
  }
  get flyerFile() {
    return this.myForm.controls['flyerFile'] as FormControl;
  }

  uploadProduct() {
    this.submitted = true;

    const bula = this.flyerFile?.value;
    const imgFile = this.imgFile?.value;
    const newProductFile = this.imgProduct?.value;
    const technicalFile = this.technicalFile?.value;

    const formData: FormData = new FormData();
    if (bula) {
      formData.append('Files', bula, 'Bula.' + bula.type.replace(/(.*)\//g, ''));
    }
    if (technicalFile) {
      formData.append('Files', technicalFile, 'TechnicalFile.' + technicalFile.type.replace(/(.*)\//g, ''));
    }
    formData.append('Files', imgFile, 'Imagem.' + imgFile.type.replace(/(.*)\//g, ''));
    formData.append('Files', newProductFile, 'NewProductFile.' + newProductFile.name.split('.').pop());


    if (this.myForm.valid) {   
      this.isLoading = true;   
      this.createProductService.SubmitNewProduct(formData,this.loggedUser.username,this.loggedUser.userId).subscribe({
        next: (resp) => {
          if (resp) {
            this.snackBarService.openSnackBar(
              'Ação concluida com sucesso',
              '#0AA174',
              '../../../assets/Icons/correct.png'
            );
            this.myForm.reset();
            this.isLoading = false;
          }
        },
        error: (e) => {
          this.snackBarService.openSnackBar(
            `Ocorreu um erro`,
            '#F97066',
            '../../../assets/Icons/ErrorIcon.png'
          );
          console.error(e);
          this.isLoading = false;
        },
      });
    } else {
      this.snackBarService.openSnackBar(
        `Campos não preenchidos`,
        '#F97066',
        '../../../assets/Icons/ErrorIcon.png'
      );
    }
  }

  onProductDownload() {
    let fileUrl: string = `${environment.uploadTemplates}TemplateProdutos.xlsx`;
    window.open(fileUrl, '_blank');
    this.snackBarService.openSnackBar(
      'Download concluido com sucesso',
      '#0AA174',
      '../../../assets/Icons/correct.png'
    );
  }

  onFileChange(event: Event, control: FormControl): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      control.setValue(file);
      control.markAsTouched();
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      if (this.isExcelFile(file.name)) {
        this.imgProduct.setValue(file);
        this.imgProduct.markAsTouched();
      } else {
        this.imgProduct.reset();
        (event.target as HTMLInputElement).value = '';
        this.snackBarService.openSnackBar(
          'Tipo de ficheiro inválido',
          '#F97066',
          '../../../assets/Icons/ErrorIcon.png'
        );
      }
    }
  }

  isExcelFile(fileName: string): boolean {
    return fileName.endsWith('.xls') || fileName.endsWith('.xlsx');
  }
}
